export const navigation = () => {

	toggleNavigation()
	submenus()
}

let toggleNavigation = () => {

	let buttons = document.querySelectorAll('[data-toggle-navigation]')

	if (!buttons.length) return

	buttons.forEach(button => {
		button.addEventListener('click', e => {
			if (document.body.getAttribute('data-navigation-status') == 'open') {
				document.body.removeAttribute('data-navigation-status')
			} else {
				document.body.setAttribute('data-navigation-status', 'open')
			}
			e.preventDefault()
		})
	})

	document.onkeydown = e => {
		e = e || window.event
		if (e.keyCode == 27) document.body.removeAttribute('data-navigation-status')
	}

}

let submenus = () => {

	let header = document.querySelector('[data-site-header]')

	if (!header) return false

	let parentMenuItems = header.querySelectorAll('.top-level-solutions, .top-level-resources, .top-level-company'),
		overlay = header.querySelector('[data-submenu-overlay]')

	parentMenuItems.forEach(menuItem => {
		menuItem.addEventListener('click', e => {
			if (menuItem.classList.contains('top-level-solutions') && document.body.getAttribute('data-current-submenu') !== 'solutions') {
				document.body.setAttribute('data-current-submenu', 'solutions')
			} else if (menuItem.classList.contains('top-level-resources') && document.body.getAttribute('data-current-submenu') !== 'resources') {
				document.body.setAttribute('data-current-submenu', 'resources')
			} else if (menuItem.classList.contains('top-level-company') && document.body.getAttribute('data-current-submenu') !== 'company') {
				document.body.setAttribute('data-current-submenu', 'company')
			} else {
				document.body.setAttribute('data-current-submenu', 'none')
			}
			e.preventDefault()
		})
	})

	if (overlay) {
		overlay.addEventListener('click', e => {
			document.body.setAttribute('data-current-submenu', 'none')
		})
	}

	document.onkeydown = e => {
		e = e || window.event
		if (e.keyCode == 27) document.body.setAttribute('data-current-submenu', 'none')
	}

}

export default () => { }